/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    getAll: async (params) => exeRequest(`/admin/clients${buildQuery(params)}`, "GET"),

    getById: async (id) => exeRequest(`/admin/clients/${id}`, "GET"),

    create: async (data) => exeRequest(`/admin/clients`, "POST", data),

    update: async (id, data) => exeRequest(`/admin/clients/${id}`, "PUT", data),

    delete: async (id) => exeRequest(`/admin/clients/${id}`, "DELETE"),

    search: async (query) => exeRequest(`/admin/clients/search?q=${encodeURIComponent(query)}`, "GET"),

    getStats: async (params) => exeRequest(`/admin/clients/stats${buildQuery(params)}`, "GET"),

    getSituation: async (id) => exeRequest(`/admin/clients/${id}/situation`, "GET"),
};
